import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
class Inspirationhp extends lm.Composant {
  /**
   * @constructor
   * @param {String} id
   */
  constructor(id) {
    super(id);

    // Init Mozaic Carousel
    [...document.querySelectorAll('.mc-carousel')].forEach(element => {
      new Carousel(element);
    });
  }
}
function initInspirationhp() {
  new Inspirationhp('inspirationhp');
}
if (document.readyState === 'loading') {
  globalThis.addEventListener('DOMContentLoaded', initInspirationhp);
} else {
  initInspirationhp();
}